import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoCarreras from './components/ListadoCarreras';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allCarrerasAction, setActivoCarrerasAction } from './CarrerasAction';
import FormCarreras from './components/FormCarreras';
import { ModalComponent } from '../../../widgets';

const CarrerasView = () => {
  const dispatch = Redux.useDispatch();

  const carrerasStore = Redux.useSelector((state) => state.carreras);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoCarrerasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoCarrerasAction(dispatch, null);
            await allCarrerasAction(dispatch, carrerasStore.params);
          }}
          disabled={carrerasStore.all.length === 0 || carrerasStore.loadingAll}
          white
          refreshIcon
          text={carrerasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoCarreras
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormCarreras"
        title={
          carrerasStore.activo
            ? `Editar ${carrerasStore.activo.nombre}`
            : 'Nueva carrera'
        }
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormCarreras
          activo={carrerasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default CarrerasView;
